// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.available-labour-sundry[data-v-28a8a289] {\n  /* Add your component styles here */\n}\n", ""]);
// Exports
module.exports = exports;
